import {
  HeroModal as Modal,
  ModalBody,
  ModalContent,
  ModalFooter
} from 'src/shared/components/ui';
import { Typography } from 'src/shared/components/ui';
import { ButtonV2 } from 'src/shared/components/ui';

interface LeaveDraftModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const LeaveDraftModal: React.FC<LeaveDraftModalProps> = ({
  isOpen,
  onClose,
  onConfirm
}) => {
  return (
    <Modal
      backdrop="blur"
      isOpen={isOpen}
      onOpenChange={onClose}
      placement="center"
      size="md"
    >
      <ModalContent className="p-6">
        <ModalBody className="p-0 gap-2">
          <Typography variant="h5" weight="bold">
            Leave this page?
          </Typography>
          <Typography variant="body-1" className="text-secondary-text">
            Your progress will be saved as a draft. You can continue editing it
            later from your products page.
          </Typography>
        </ModalBody>
        <ModalFooter className="p-0 pt-6 gap-3">
          <ButtonV2 color="tertiary" onPress={onClose} className="flex-1">
            Stay
          </ButtonV2>
          <ButtonV2 color="primary" onPress={onConfirm} className="flex-1">
            Leave
          </ButtonV2>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default LeaveDraftModal;
